import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Select, 
  MenuItem,
  TablePagination, Button, TextField
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { CSVLink } from "react-csv";
import { SearchInput } from 'components';
import { getInitials } from 'helpers';
import { Markup } from 'interweave';

const useStyles = makeStyles(theme => ({
  root: { padding: theme.spacing(3) },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1)
  }
}));

const filterOptions = [
  {
    value: 'aui_id',
    label: 'AUI ID'
  },
  {
    value: 'first_name',
    label: 'First Name'
  },
  {
    value: 'last_name',
    label: 'Last Name'
  },
  {
    value: 'school',
    label: 'School'
  },
  {
    value: 'major',
    label: 'Major'
  }
];

const UsersTable = props => {
  const { className, users, motivationLetter, history, ...rest } = props;

  // console.log(users);
  const classes = useStyles();
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [openMotivationLetterDialog, setOpenMotivationLetterDialog] = useState(false  );
  const [dialogTabIndex, setDialogTabIndex] = useState(0  );
  const [dialogLetter, setDialogLetter] = useState(''  );

  const [filterValue, setFilterValue] = useState('aui_id');
  const [searchValue, setSearchValue] = useState('');

  const handleSearchChange = (event) => {
    event.persist();
    if(event.target.value.match(/^[a-zA-Z0-9\s._èéêàá?!\[\]();,-]*$/)) {
      setSearchValue(event.target.value);
    }
  };
  const handleFilterChange = (event) => {
    event.persist();
    if(event.target.value.match(/^[a-zA-Z0-9\s._èéêàá?!\[\]();,-]*$/)) {
      setFilterValue(event.target.value);
    }
  };
  let csvData = [
    ["Name", "Email", "AUI ID", "Phone", "School", "Major", "Minor", "Status", "CV Link"],
  ];

  users.map(user => {
    //Creating CSV file
    csvData.push([user.first_name + user.last_name, user.email, user.aui_id, user.phone_number, user.school, user.major, user.minor, user.is_alumni?'Alumni':'Student', user.cv_url])
    //Setting all motivation dialog boxes to false

  })

  const handleClickOpenDialog = (index)  => {
    setDialogLetter(users[index].motivation_letter);
    setDialogTabIndex(users[index].aui_id);
    setOpenMotivationLetterDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenMotivationLetterDialog(false);
  };

  const descriptionElementRefDialog = React.useRef(null);
  React.useEffect(() => {
    if (openMotivationLetterDialog) {
      const { current: descriptionElement } = descriptionElementRefDialog;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [openMotivationLetterDialog]);

  const handleSelectAll = event => {
    const { users } = props;
    let selectedUsers;

    if (event.target.checked) {
      selectedUsers = users.map(user => user.id);
    } else {
      selectedUsers = [];
    }

    setSelectedUsers(selectedUsers);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedUsers.indexOf(id);
    let newSelectedUsers = [];

    if (selectedIndex === -1) {
      newSelectedUsers = newSelectedUsers.concat(selectedUsers, id);
    } else if (selectedIndex === 0) {
      newSelectedUsers = newSelectedUsers.concat(selectedUsers.slice(1));
    } else if (selectedIndex === selectedUsers.length - 1) {
      newSelectedUsers = newSelectedUsers.concat(selectedUsers.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedUsers = newSelectedUsers.concat(
        selectedUsers.slice(0, selectedIndex),
        selectedUsers.slice(selectedIndex + 1)
      );
    }

    setSelectedUsers(newSelectedUsers);
  };

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };
  const handledViewSelectedProfileBtn = event => {
    // console.log("selection", selectedUsers);
    history.push({
      pathname: '/view-profiles',
      usersList: selectedUsers,
    });
  }

  return (
    <div>
      <div className={classes.root}>
        <div
          {...rest}
          className={clsx(classes.root, className)}
        >
          <div className={classes.row}>
            <span className={classes.spacer} />
            <CSVLink
              data={csvData}
              filename={"Seekers.csv"}
              className="btn btn-primary"
              target="_blank"
            >
              <Button className={classes.exportButton}> Export</Button>
            </CSVLink>

            <Button
              color="primary"
              variant="contained"
              onClick={handledViewSelectedProfileBtn}
            >
              View Selected Profiles
            </Button>
          </div>
          <div className={classes.row}>
            <Select
              style={{background: 'white', width: 130}}
              fullWidth
              label="Filter"
              margin="dense"
              name="filter"
              value={filterValue || ''}
              onChange={handleFilterChange}
              required
              select
              // eslint-disable-next-line react/jsx-sort-props
              SelectProps={{native: true}}
              value={filterValue}
              variant="outlined"
            >
              {filterOptions.map(option => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            <SearchInput
              className={classes.searchInput}
              placeholder="Search"
              value={searchValue}
              onChange={handleSearchChange}
            />
          </div>
        </div>
      </div>
      <div className={classes.content}>
        <Card
          {...rest}
          className={clsx(classes.root, className)}
        >
          <CardContent className={classes.content}>
            <PerfectScrollbar>
              <div className={classes.inner}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedUsers.length === users.length}
                          color="primary"
                          indeterminate={
                            selectedUsers.length > 0 &&
                        selectedUsers.length < users.length
                          }
                          onChange={handleSelectAll}
                        />
                      </TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Email</TableCell>
                      <TableCell>AUI ID</TableCell>
                      <TableCell>Phone</TableCell>
                      <TableCell>School</TableCell>
                      <TableCell>Major</TableCell>
                      <TableCell>Minor</TableCell>
                      <TableCell>Status</TableCell>
                      {
                        (motivationLetter)?
                          <TableCell>Motivation Letter</TableCell>
                          :<div></div>
                      }
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {users.filter(d => d[filterValue].includes(searchValue)).slice(0, rowsPerPage).map((user, index) => (
                      (!user)?<div />
                        :
                        <TableRow
                          className={classes.tableRow}
                          hover
                          key={user.hashed_id}
                          selected={selectedUsers.indexOf(user.hashed_id) !== -1}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={selectedUsers.indexOf(user.hashed_id) !== -1}
                              color="primary"
                              onChange={event => handleSelectOne(event, user.hashed_id)}
                              value="true"
                            />
                          </TableCell>
                          <TableCell>
                            <div className={classes.nameContainer}>
                              <Avatar
                                className={classes.avatar}
                                src={user.profile_picture}
                              >
                                {getInitials(user.first_name + ' ' + user.last_name)}
                              </Avatar>
                              <Typography variant="body1">{user.first_name} {user.last_name}</Typography>
                            </div>
                          </TableCell>
                            <TableCell>{user.email}</TableCell>

                          <TableCell>
                            {user.aui_id}
                          </TableCell>
                          <TableCell>{user.phone_number}</TableCell>
                          <TableCell>
                            {user.school}
                          </TableCell>
                          <TableCell>
                            {user.major}
                          </TableCell>
                          <TableCell>
                            {user.minor}
                          </TableCell>
                          <TableCell>
                            {user.is_alumni?'Alumni':'Student'}
                          </TableCell>
                          {
                            (motivationLetter)?
                              <div>
                              <TableCell>
                                <Button onClick={() => {handleClickOpenDialog(index)}} variant="contained" color="secondary">

                                  View
                                </Button>
                              </TableCell>

                              </div>
                              :<div></div>
                          }
                        </TableRow>
                    ))}

                    <Dialog
                      open={openMotivationLetterDialog}
                      onClose={handleCloseDialog}
                      scroll={"paper"}
                      aria-labelledby="scroll-dialog-title"
                      aria-describedby="scroll-dialog-description"
                    >
                      <DialogTitle id="scroll-dialog-title">Motivation Letter</DialogTitle>
                      <DialogContent dividers={true}>
                        <Markup content={dialogLetter} />
                        {/*<DialogContentText*/}
                        {/*  id="scroll-dialog-description"*/}
                        {/*  ref={descriptionElementRefDialog}*/}
                        {/*  tabIndex={dialogTabIndex}*/}
                        {/*>*/}
                        {/*  {dialogLetter}*/}
                        {/*</DialogContentText>*/}
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleCloseDialog} color="primary">
                          Back
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </TableBody>
                </Table>
              </div>
            </PerfectScrollbar>
          </CardContent>
          <CardActions className={classes.actions}>
            <TablePagination
              component="div"
              count={users.length}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              page={page}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </CardActions>


        </Card>

      </div>
    </div>
  );
};

UsersTable.propTypes = {
  className: PropTypes.string,
  users: PropTypes.array.isRequired
};

export default UsersTable;
